export const adminName = "Beheerder";
export const serverUrl = "https://backend.plantenkwekerijblondeel.be/api";
